export const liveSearch = {
  AUTOCOMPLETE: 'liveSearch.autocomplete'
}
